@if (isInitialized) {
<oe-navigation-view [title]="'GENERAL.PRODUCTION' | translate">
    <ion-buttons header class="ion-justify-content-center">
        <div #ref><ng-content select="[custom-pickdate]"></ng-content></div>
        @if (!ref.children.length) {
        <pickdate></pickdate>
        }
    </ion-buttons>
    <oe-common-production-total-chart [isOnlyChart]="true">
    </oe-common-production-total-chart>
</oe-navigation-view>
}